/** Pick a sensible default scrub date: today when in range, otherwise range bounds. */
export function getDefaultTimelineDate(startDate: Date, endDate: Date): Date {
  const today = new Date();
  today.setHours(12, 0, 0, 0);
  if (today.getTime() < startDate.getTime()) {
    return startDate;
  }
  if (today.getTime() > endDate.getTime()) {
    return endDate;
  }
  return today;
}

export type TimelineDateRange = {
  startDate: Date;
  endDate: Date;
};

/** Map a date to 0–1 progress within a visible range. */
export function dateToTimelineProgress(date: Date, range: TimelineDateRange): number {
  const total = range.endDate.getTime() - range.startDate.getTime();
  if (total <= 0) {
    return 0;
  }
  const elapsed = date.getTime() - range.startDate.getTime();
  return Math.max(0, Math.min(1, elapsed / total));
}

/** Map 0–1 progress to a date within a visible range. */
export function timelineProgressToDate(
  progress: number,
  range: TimelineDateRange,
): Date {
  const total = range.endDate.getTime() - range.startDate.getTime();
  const clamped = Math.max(0, Math.min(1, progress));
  return new Date(range.startDate.getTime() + total * clamped);
}

/** Clamp a date to the inclusive bounds of a visible range. */
export function clampDateToRange(date: Date, range: TimelineDateRange): Date {
  if (date.getTime() < range.startDate.getTime()) {
    return range.startDate;
  }
  if (date.getTime() > range.endDate.getTime()) {
    return range.endDate;
  }
  return date;
}
